<template>
	<b-modal
		:id="$attrs.id"
		size="sm"
		dialog-class="confirm-modal"
		content-class="confirm-modal__content"
		body-class="d-flex flex-column justify-content-center align-items-center p-4"
		centered
		hide-header
		hide-footer
		no-close-on-backdrop
		no-close-on-esc
	>
		<template v-slot:default="{ close }">
			<h5 class="confirm-modal__title">{{ title }}</h5>
			<p class="confirm-modal__text">{{ content }}</p>
			<div>
				<button
					class="btn btn-rounded btn-outline-primary btn-cancel mr-3"
					@click="
						$emit('cancelled');
						close();
					"
				>
					{{ cancelText || "Cancel" }}
				</button>
				<button
					class="btn btn-rounded btn-primary btn-ok"
					@click="
						$emit('confirmed');
						close();
					"
				>
					{{ confirmText || "OK" }}
				</button>
			</div>
		</template>
	</b-modal>
</template>

<script>
export default {
	name: "ConfirmModal",
	props: {
		title: {
			type: String,
			default: "Rakuten"
		},
		content: {
			type: String,
			default: ""
		},
		confirmText: String,
		cancelText: String
	},
	data() {
		return {};
	},
	mounted() {},
	methods: {}
};
</script>

<style lang="scss" scoped>
.btn-cancel,
.btn-ok {
	font-weight: 700;
	min-width: 14rem;
	padding: 0.7rem 2rem;
    background-color: #E50113;
	color: white;
	border: none;
	&:hover {
    	background-color: #72040d;
	}
}

.btn-cancel {
	background-color: #1D2087;
	&:hover,
	&:active {
		color: $color-white !important;
	}
	&:hover {
    	background-color: #5459f3;
	}
}
p {
	margin: 2rem 0 2.5rem;
	text-align: center;
	font-weight: 700;
}

h5 {
	font-weight: 700;
	font-size: 1.8rem;
}
.confirm-modal {
	&__title {
		text-align: center;
	}
	&__text {
		font-style: italic;
		opacity: 0.8;
		color: #e40215;
	}
}
</style>
